import { add, Dinero } from "dinero.js"

import { DateTimeFactory } from "../../../../../../modules/localization/useDateTime"
import { toDinero } from "../../../../../../modules/currency/currencyLib"
import { MeetingServiceOrder } from "../../../../../../modules/merchant/accounting/accounting/accountingTypes"
import { OrderLineType } from "../../../createOrderTypes"
import { DeliveryWithCart } from "../../form/formTypes"

export function buildInitialQuantityKey({
    deliveryTime,
    productId,
    isExtraService,
}: Readonly<{
    deliveryTime: string
    productId: string | number
    isExtraService?: boolean
}>) {
    return `${deliveryTime}|${productId}|${isExtraService ? "1" : "0"}`
}

export function buildInitialRefundQuantitiesFromOrderDetails(
    orderDetails: MeetingServiceOrder | undefined,
    dateTimeFactory: DateTimeFactory,
): Record<string, number> {
    const initial: Record<string, number> = {}
    if (!orderDetails?.deliveries) return initial

    for (const delivery of orderDetails.deliveries) {
        const time = dateTimeFactory.toHourMinute(dateTimeFactory.fromApi(delivery.deliveryTime))
        for (const line of delivery.orderLines) {
            const isExtraService = line.type === OrderLineType.EXTRA_SERVICE
            const key = buildInitialQuantityKey({
                deliveryTime: time,
                productId: line.productId,
                isExtraService,
            })
            initial[key] = (initial[key] ?? 0) + (line.items ?? 0)
        }
    }

    return initial
}

export function calculateTotalAmountFromDeliveries(
    deliveryTimes: DeliveryWithCart[],
    fallbackCurrency: string = "DKK",
): Dinero<number> {
    const defaultPrice = toDinero({ amount: 0, scale: 2, currency: fallbackCurrency })

    return deliveryTimes.reduce((total: Dinero<number>, delivery) => {
        const deliveryTotal = delivery.orderLines.reduce((sum, p) => {
            return add(
                sum,
                p.price
                    ? toDinero({
                          amount: p.price.amount * p.quantity,
                          scale: p.price.scale,
                          currency: p.price.currency,
                      })
                    : defaultPrice,
            )
        }, defaultPrice)

        return add(total, deliveryTotal)
    }, defaultPrice)
}
